import { MODAL_ACTIONS } from './actionTypes';
import { IModalAction, IModalState } from './interfaces';

const modalReducer = (state: IModalState = {}, action: IModalAction) => {
  switch (action.type) {
    case MODAL_ACTIONS.ToggleOpen:
      return {
        ...state,
        [action.name]: { ...(action.payload ? { data: action.payload } : {}), isOpen: true },
      };

    case MODAL_ACTIONS.ToggleClose:
      return {
        ...state,
        [action.name]: {
          ...state[action.name],
          isOpen: false,
        },
      };

    case MODAL_ACTIONS.ClearData:
      return state[action.name]
        ? {
            ...state,
            [action.name]: {
              isOpen: state[action.name].isOpen,
            },
          }
        : state;
    default:
      return state;
  }
};

export default modalReducer;
